module.exports = __webpack_public_path__ + "82b7cd47f980479d0afaba46c6841a53.png";